import request from '@/utils/request'

//上传文件
export const uploadFile = (data) => {
  let headers = {
    'Content-Type': 'multipart/form-data',
  }

  return request({ url: '/upload_file', method: 'POST', data, headers })
}
